import { Text, Flex, Tooltip } from '@chakra-ui/react';
import { checkSelectedActiveRow } from '../../../utils/market-development';
import { useTranslation } from 'react-i18next';
import useStore from '../../../store';

export default function SpreadSheetProductList({ type = null, label = null, labelMarginTop = '0px', provinces = [], active = null }) {
	const { t } = useTranslation();
	const { currentLang: lang } = useStore((state) => state.currentLang);

	return (
		<>
			<div className="product-list">
				<>
					{label && (
						<>
							<Flex alignItems="center" mt={labelMarginTop} w="340px" h="30px" borderLeft="1px solid hsl(2deg, 0%, 91%)" pl={2} pr={2}>
								<Tooltip label={t(label)}>
									<Text color="#d35400" fontSize="md" fontWeight="semibold">
										{t(label)}
									</Text>
								</Tooltip>
							</Flex>
						</>
					)}
				</>
				{provinces?.map((el, i) => (
					<Flex
						key={`product-line-item-${i}`}
						className={checkSelectedActiveRow(active, i, type) ? 'active-row' : ''}
						alignItems="center"
						h="30px"
						border="1px solid hsl(2deg, 0%, 91%)"
						backgroundColor="#f7fafc"
						borderBottomWidth={i === provinces?.length - 1 ? 1 : 0}
						pl={2}
						pr={2}
					>
						<Tooltip label={lang === 'kh' ? el?.name : el?.latinName}>
							<Text ml="4px" color="#0173BB" fontWeight="bold" isTruncated>
								{lang === 'kh' ? el?.name : el?.latinName}
							</Text>
						</Tooltip>
					</Flex>
				))}
			</div>
		</>
	);
}
